import React from 'react';
import {PaginationProps, PaginationState} from '@src/@types/components/Pagination';
import StandardPagination from './StandardPagination';
import {IListPaginationHttpResponse} from '@src/@interfaces/components/List/IListPaginationHttpResponse';
import {IListNPlus1PaginationHttpResponse} from '@src/@interfaces/components/List/IListNPlus1PaginationHttpResponse';

export default class Pagination extends React.PureComponent<PaginationProps, PaginationState> {
    state: PaginationState = {};

    constructor(props: PaginationProps) {
        super(props);

        this.state = this.derivePropsFromState(props);
    }

    componentDidUpdate(prevProps: Readonly<PaginationProps>, prevState: Readonly<PaginationState>) {
        const toString = (state: any): string => JSON.stringify(state);
        const prevStateString = toString(prevState);
        const nextState = this.derivePropsFromState(this.props);
        const nextStateString = toString(nextState);

        if (Object.keys(nextState).length > 0 && prevStateString !== nextStateString) {
            this.setState(nextState);
        }
    }

    render() {
        const response = this.props.response ?? this.state.prevPageState;
        if (Pagination.isNPlus1Response(response)) {
            return this.renderNPlus1Pagination(response);
        }

        if (Pagination.isPaginationResponse(response)) {
            return this.renderStandardPagination(response);
        }

        return null;
    }

    protected renderNPlus1Pagination(response: Pick<IListNPlus1PaginationHttpResponse, 'current_page' | 'has_next_page'>) {
        return <StandardPagination
                currentPage={response.current_page}
                lastPage={response.has_next_page ? response.current_page + 1 : response.current_page}
                onClick={this.props.onClick}
                paginationProps={this.props.paginationProps}
                isIsolatedComponent={this.props.isIsolatedComponent}
                pageNumberGetParamName={this.props.pageNumberGetParamName}
        />;
    }

    protected renderStandardPagination(response: Pick<IListPaginationHttpResponse, 'current_page' | 'last_page'>) {
        return <StandardPagination
                currentPage={response.current_page}
                lastPage={response.last_page}
                onClick={this.props.onClick}
                paginationProps={this.props.paginationProps}
                isIsolatedComponent={this.props.isIsolatedComponent}
                pageNumberGetParamName={this.props.pageNumberGetParamName}
        />;
    }

    public static isNPlus1Response(response: any): response is IListNPlus1PaginationHttpResponse {
        return response && 'has_next_page' in response;
    }

    public static isPaginationResponse(response: any): response is IListPaginationHttpResponse {
        return response && 'last_page' in response;
    }

    protected derivePropsFromState(props: PaginationProps): PaginationState {
        if (!props.response) {
            return {};
        }

        const response = props.response;
        if (Pagination.isNPlus1Response(response)) {
            return {
                prevPageState: {
                    current_page: response.current_page,
                    last_page: undefined,
                    has_next_page: response.has_next_page,
                }
            };
        }

        return {
            prevPageState: {
                current_page: response.current_page,
                last_page: response.last_page,
                has_next_page: undefined,
            }
        };
    }
}
